import React from 'react'
import InputRange from 'react-input-range'
import '../../../../node_modules/react-input-range/src/scss/index'
import PropTypes from 'prop-types'
import './FilterRangeSlider.scss'

class FilterRangeSlider extends React.Component {
  constructor (props) {
    super(props)

    this.sliderMax = props.allowOverMax
      ? props.rangeMax + props.step
      : props.rangeMax

    this.renderRangeLabel = this.renderRangeLabel.bind(this)
  }

  renderRangeLabel ({ min, max }) {
    if (min === this.props.rangeMin && max === this.sliderMax) {
      return 'All Durations'
    } else {
      if (max > this.props.rangeMax) {
        max = `${this.props.rangeMax}+`
      }
      return `${min} - ${max}`
    }
  }

  render () {
    let sliderValues = {
      min: this.props.values.min || this.props.rangeMin,
      max: this.props.values.max || this.sliderMax
    }

    return (
      <div
        className={`FilterRangeSlider ${
          this.props.lightVersion ? 'FilterRangeSlider--light' : ''
        }`}
      >
        <InputRange
          minValue={this.props.rangeMin}
          maxValue={this.sliderMax}
          step={this.props.step}
          value={sliderValues}
          onChange={minMax => {
            this.props.onChange(minMax)
          }}
          onChangeComplete={minMax => {
            let min = minMax.min
            let max = minMax.max > this.props.rangeMax ? null : minMax.max
            this.props.onSlideEnd({
              min,
              max
            })
          }}
          formatLabel={val => {
            let rangeValue = val
            if (rangeValue > this.props.rangeMax) {
              rangeValue = `${this.props.rangeMax}+`
            }
            return (
              <React.Fragment>
                <span className='range-val'>{rangeValue} </span>
                <span>Mins</span>
              </React.Fragment>
            )
          }}
        />
        <div className='label-container'>
          <span>{this.renderRangeLabel(sliderValues)}</span>
        </div>
      </div>
    )
  }
}

FilterRangeSlider.defaultProps = {
  step: 1
}

FilterRangeSlider.propTypes = {
  allowOverMax: PropTypes.bool,
  rangeMin: PropTypes.number,
  rangeMax: PropTypes.number,
  step: PropTypes.number,
  values: PropTypes.object,
  onChange: PropTypes.func,
  onSlideEnd: PropTypes.func,
  lightVersion: PropTypes.bool
}

export default FilterRangeSlider
